import { gql, TypedDocumentNode } from '@common/hooks';
import {
  MissionControlComplianceCountersQueryQueryCgResponse,
  MissionControlComplianceCountersQueryQueryVariables,
} from '@common/graphql';

export const MISSION_CONTROL_COMPLIANCE_COUNTERS_QUERY: TypedDocumentNode<
  MissionControlComplianceCountersQueryQueryCgResponse,
  MissionControlComplianceCountersQueryQueryVariables
> = gql`
  query MissionControlComplianceCountersQuery {
    missionControlComplianceCounters {
      expiredDocuments
      expiringDocuments
      missingComplianceCandidates
    }
  }
`;
